import { Table, TableBody, TableCell, TableRow, Typography, WithStyles, withStyles } from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { isNil, orderBy } from "lodash";
import * as React from "react";

import { User } from "../../models/User.model";
import { AdvisorStats } from "../../types/RootState";
import TableHeadSortable from "../TableHeadSortable/TableHeadSortable";
import { styles } from "./AdvisorTable.style";

interface AdvisorTableProps {
    background?: string;
    advisors: User[];
    advisorsStats: { [userId: string]: AdvisorStats };
    onSurrogateClick?: (advisor: User) => void;
}
interface AdvisorTableState {
    filter: string;
    order: "asc" | "desc";
}

const rows = [
    { id: "lastname", label: "Nom" },
    { id: "firstname", label: "Prénom" },
    { id: "stats", label: "Statistique du mois" },
];

class AdvisorTable extends React.Component<AdvisorTableProps & WithStyles<typeof styles>, AdvisorTableState> {
    state: AdvisorTableState = {
        order: "asc",
        filter: "date",
    };

    public render() {
        const { classes, advisors } = this.props;
        const { order, filter } = this.state;

        const orderedAdvisors: User[] = orderBy(
            advisors,
            (advisor) => {
                // TODO: @bm - merge into customer data?
                switch (filter) {
                    case "lastname":
                        return advisor.lastname;
                    case "firstname":
                        return advisor.firstname;
                    case "stats":
                        return 1;
                    default:
                        return advisor.createdAt;
                }
            },
            [order]
        );

        return (
            <Table>
                <TableHeadSortable
                    order={order}
                    orderBy={filter}
                    rows={rows}
                    onRequestSort={(property: string) => this.handleRequestSort(property)}
                />

                <TableBody>
                    {orderedAdvisors.length > 0 ? (
                        orderedAdvisors.map((advisor) => (
                            <TableRow className={classes.row} key={advisor.id}>
                                <TableCell className={classes.cell}>
                                    <Typography>{advisor.lastname}</Typography>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    <Typography>{advisor.firstname}</Typography>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    <Typography>{this.getStats(advisor)}</Typography>
                                </TableCell>
                                <TableCell className={classes.cell}>
                                    <Typography
                                        className={classes.cellLink}
                                        onClick={() => this.props.onSurrogateClick(advisor)}
                                    >
                                        <VisibilityIcon className={classes.cellIcon} /> S'identifier à la place
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        ))
                    ) : (
                        <TableRow className={classes.row}>
                            <TableCell className={classes.cell} />
                            <TableCell className={classes.cell} />
                            <TableCell className={classes.cell}>Vous n'avez pas encore de commerciaux</TableCell>
                            <TableCell className={classes.cell} />
                            <TableCell className={classes.cell} />
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        );
    }
    private getStats(advisor: User): string {
        if (isNil(this.props.advisorsStats) || isNil(this.props.advisorsStats[advisor.id])) return "-";
        return `${this.props.advisorsStats[advisor.id].nbQuotationsForLastMonth}`;
    }

    private handleRequestSort(property: string) {
        this.setState({
            order: this.state.filter === property && this.state.order === "desc" ? "asc" : "desc",
            filter: property,
        });
    }
}

export default withStyles(styles)(AdvisorTable);



// WEBPACK FOOTER //
// ./src/components/AdvisorTable/AdvisorTable.tsx